export const title = "Economia para o seu cliente";
export const description = "Faça a simulação abaixo e veja o quanto seu cliente pode economizar.";